import FormErrorConstants from '../../../utils/form-error-constants';
import common from '../../../module/common';

class ReturnRequest {
    init() {
        let deliveryButtonJQ = $('li .button.checkout');
        let requestFromJQ = $('#userInfoForm');
        let systemError = new FormErrorConstants('#userInfoForm');
        let quantityJQ = $('input.quantity');
        let self = this;

        quantityJQ.each((key, quantity) => {
            if (parseInt($(quantity).attr('max')) === 1) {
                $(quantity).attr('value', '1');
            }
        });

        quantityJQ.change(event => {
            self.checkQuantityInput();
        });

        deliveryButtonJQ.on('click', function () {
            let deliveryTypeJQ = requestFromJQ.find('[name=delivery-type]');
            deliveryTypeJQ.attr('value', $(this).closest('li').find('input').attr('id'));
            let errorFlag = self.checkQuantityInput();

            $('textarea.reason').each((index, element) => {
                systemError.hideNoticeErrorNext($(element).closest('.column-textarea'), $(element).closest('div.group'));
            });
            let emptyTextarea = $('textarea.reason:required').filter((index, element) => {
                return $(element).val().length === 0;
            });
            if (emptyTextarea.length > 0) {
                emptyTextarea.each((index, textarea) => {
                    systemError.showNoticeErrorAfter($(textarea).closest('.column-textarea'), $(textarea).closest('div.group'), systemError.constants.retour_excahnge_is_required)
                });
                errorFlag = true;
            }

            if (!errorFlag) {
                requestFromJQ.find('button#send-form-request').click();
            } else {
                self.scrollToTopErrorContainer();
            }
        });

        $('select.returnType').on('change', (event) => {
            let value = event.target.value ? parseInt(event.target.value) : 0;
            let text = $(event.target).find('option:selected').data('labelText');
            let lineID = $(event.target).attr('name').match(/\[(\d+)]/)[1];
            let reasonJQ = $(`[name="items[${lineID}][reason]"]`);

            reasonJQ.next('label').attr('ph', text).attr('fl', text);

            if (value === 1) {
                reasonJQ.removeAttr('required')
            }
            if (value === 2) {
                reasonJQ.attr('required', true);
            }
        });
        systemError.init();

    }

    checkQuantityInput() {
        let systemError = new FormErrorConstants('#userInfoForm');
        let errorFlag = false;

        $('input.quantity').each((key, quantity) => {
            let inputJQ = $(quantity);
            let quantityColumnJQ = inputJQ.closest($('.quantityColumn'));

            this.hideNoticeErrorQuantityNext(quantityColumnJQ, quantityColumnJQ.closest('div.group'));

            if (parseInt(inputJQ.attr('max')) < parseInt(inputJQ.val())) {
                this.showNoticeErrorQuantityAfter(quantityColumnJQ, quantityColumnJQ.closest('div.group'),
                    systemError.constants.retour_quantity_is_greater);
                errorFlag = true;
            } else if (!$.isNumeric(inputJQ.val()) || parseInt(inputJQ.val()) <= 0) {
                this.showNoticeErrorQuantityAfter(quantityColumnJQ, quantityColumnJQ.closest('div.group'),
                    systemError.constants.retour_quantity_number);
                errorFlag = true;
            }
        });

        return errorFlag;
    }

    showNoticeErrorQuantityAfter(element, elementAfter, message) {
        let systemError = new FormErrorConstants('#userInfoForm');
        let customMessage = `<div class="custom-error">${systemError.getNoticeErrorHtml(message)}</div>`;

        $(element).removeClass('valid').addClass('error');
        $(elementAfter).after(customMessage)
    }

    hideNoticeErrorQuantityNext(element, noticeError) {
        $(element).removeClass('error').addClass('valid');
        $(noticeError).next('.custom-error').remove();
    }

    scrollToTopErrorContainer() {
        let errorInput;
        let errorContainer = $('.custom-error, .notice').first();

        if (errorContainer.length) {
            errorInput = errorContainer.prev('.group');
            if (errorInput.length) {
               common.scrollToAnchor(errorInput);
            }
        }
    }
}

$(document).ready(function () {
    let returnRequest = new ReturnRequest();
    returnRequest.init();
});
